"use client";

import useTranslate from "@app/_hooks/useTranslate";
import Link from "@components/Link";
import type { LayoutSiteinfoFragment } from "@server/gql/graphql";
import { ChevronLeft as ArrowLeftIcon } from "lucide-react";

export default function CheckoutHeader({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data,
  locale,
}: {
  data?: LayoutSiteinfoFragment | null;
  locale?: string;
}) {
  const t = useTranslate();
  return (
    <header className="border-gray-150 sticky top-0 z-30 grid grid-cols-[3rem_auto_3rem] items-center justify-between gap-6 border-b bg-white md:h-16 lg:grid-cols-[1fr_auto_1fr]">
      <div className="flex flex-1 items-center md:min-w-[140px]">
        <Link locale={locale} className="group px-4 py-4">
          <span className="flex items-center group-hover:underline">
            <ArrowLeftIcon strokeWidth={1} className="size-4.5" />
            <span className="all-small-caps hidden pl-1.5 text-sm font-normal whitespace-nowrap uppercase lg:block">
              {t("continueShopping")}
            </span>
          </span>
        </Link>
      </div>
      <Link locale={locale} prefetch={false}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          fetchPriority="high"
          src="/images/no-ga-logo.svg"
          alt="NO GA logo"
          width={128}
          height={40}
          className="h-10 w-full object-contain transition-all duration-300 ease-out lg:h-12"
        />
      </Link>
    </header>
  );
}
